module.exports = __webpack_public_path__ + "static/new-ads-logo-c620875bb525883dcd1884b2ef5f387a.png";